<!--
*****************************************************************************
*File : dpu-live-view.vue
*Module : Dashboard Frontend
*Purpose : Display the footer content.
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-footer
    id="dashboard-core-footer"
  >
    <v-container>
      <v-row
        align="center"
        no-gutters
      >

        <v-spacer class="hidden-sm-and-down" />
        <v-col>
          <div class="pt-6 pt-md-0 pr-4 text-end" > 
            <a target="_blank" href="https://iisc.ac.in/">     
            <img
            contain           
            src="../../../../assets/images/IISc_logo.png"
            style="object-fit: contain;width:100px;height: 60px;margin-left: 4% !important;"
            />
            </a>   
            <a target="_blank" href="https://dfccil.com/">   
            <img
            contain           
            src="../../../../assets/images/DFCCIL1.png"
            style="object-fit: contain;width: 100px;height: 50px;margin-left: 4% !important;"
            />
            </a>
            <a target="_blank" href="https://l2mrail.com/">   
            <img
            contain           
            src="../../../../assets/images/L2M-Logo.png"
            style="object-fit: contain;width:100px;height: 50px;margin-left: 4% !important;"
            />
            </a>
          </div>
        </v-col>
        <v-col
          cols="12"
          class="text-end"
        >
          <v-card-text class="body-1 font-weight-light pt-6 pt-md-0 pr-4 text-end ">
            &copy; {{ new Date().getFullYear() }} by <a href="https://www.l2mrail.com" target="_blank">Lab To Market Innovations Pvt. Ltd</a>.
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      links: [
        {
          href: '#',
          text: 'Creative Tim'
        },
        {
          href: '#',
          text: 'About Us'
        },
        {
          href: '#',
          text: 'Blog'
        },
        {
          href: '#',
          text: 'Licenses'
        }
      ]
    })
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      color: #3c4858
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
